import { render, staticRenderFns } from "./StudentReserve.vue?vue&type=template&id=1c6a207f&scoped=true&lang=pug&"
import script from "./StudentReserve.vue?vue&type=script&lang=ts&"
export * from "./StudentReserve.vue?vue&type=script&lang=ts&"
import style0 from "./StudentReserve.vue?vue&type=style&index=0&id=1c6a207f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a207f",
  null
  
)

export default component.exports